import { DispatchRecord } from "../types/alerting";

export type Outcome = "delivered" | "withheld" | "undelivered";

const RECIPIENT_CHOICE = ["CHANNEL_DISABLED", "SNOOZED"];

/** Resolves a dispatch record into the one outcome a dispute turns on. Total: never throws. */
export const outcomeOf = (record: DispatchRecord): Outcome => {
  if (!record || record.suppressed !== true) return "delivered";

  const reason = String(record.suppressionReason ?? "").trim().toUpperCase();
  return RECIPIENT_CHOICE.includes(reason) ? "withheld" : "undelivered";
};
